var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0013 0.667969C4.4013 0.667969 0.667969 4.4013 0.667969 9.0013C0.667969 13.6013 4.4013 17.3346 9.0013 17.3346C13.6013 17.3346 17.3346 13.6013 17.3346 9.0013C17.3346 4.4013 13.6013 0.667969 9.0013 0.667969ZM9.83464 3.41797L10.9596 2.6263C12.4763 3.09297 13.768 4.09297 14.6096 5.40964L14.2846 6.5263L13.1596 6.90964L9.83464 4.58464V3.41797ZM7.04297 2.6263L8.16797 3.41797V4.58464L4.84297 6.90964L3.71797 6.5263L3.39297 5.40964C4.23464 4.1013 5.5263 3.1013 7.04297 2.6263ZM4.9013 13.2596L3.9513 13.343C2.94297 12.1763 2.33464 10.6596 2.33464 9.0013C2.33464 8.9013 2.34297 8.80964 2.3513 8.70964L3.18464 8.1013L4.33464 8.5013L5.5513 12.118L4.9013 13.2596ZM11.0846 15.3263C10.4263 15.543 9.7263 15.668 9.0013 15.668C8.2763 15.668 7.5763 15.543 6.91797 15.3263L6.34297 14.0846L6.8763 13.168H11.1346L11.668 14.093L11.0846 15.3263ZM10.893 11.5013H7.10964L5.98464 8.1513L9.0013 6.03464L12.0263 8.1513L10.893 11.5013ZM14.0513 13.343L13.1013 13.2596L12.443 12.118L13.6596 8.5013L14.818 8.10964L15.6513 8.71797C15.6596 8.80964 15.668 8.9013 15.668 9.0013C15.668 10.6596 15.0596 12.1763 14.0513 13.343Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrending);
export default __webpack_public_path__ + "static/media/trending.433d0815dc96c75cfea3668143ffc2fc.svg";
export { ForwardRef as ReactComponent };